<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">
        {{ $t("islamic_finance.title") }}
      </h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">
            {{ $t("general.home") }}
          </router-link>
        </li>
        <li v-if="userType === 'supplier'" class="breadcrumb-item">
          <router-link slot="item-title" to="/supplier/funders">
            {{ $tc("funders.finance", 2) }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $t("islamic_finance.title") }}
          </router-link>
        </li>
      </ol>
      <div v-if="userType === 'supplier'" class="page-actions row">
        <div class="col-xs-2 mr-4">
          <div slot="item-title" class="col-xs-2">
            <base-button
              size="large"
              icon="plus"
              color="theme"
              @click="newOfferSellPage()"
            >
              {{ $t("islamic_finance.new_offer_to_Sell") }}
            </base-button>
          </div>
        </div>
      </div>
    </div>
    <single-funder-row
      v-if="userType === 'supplier'"
      :fetch-data="fetchDataFunder"
    />
    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <astronaut-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{
          $t("islamic_finance.no_offer_to_sells")
        }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("islamic_finance.list_of_offer_to_sell")
        }}</label>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ offerToSells.length }}</b>
          {{ $t("general.of") }} <b>{{ totalOfferToSells }}</b>
        </p>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllOfferToSells"
        >
        <label for="select-all" class="custom-control-label selectall">
          <span class="select-all-label">{{ $t("general.select_all") }} </span>
        </label>
      </div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              >
              <label :for="row.id" class="custom-control-label" />
            </div>
          </template>
        </table-column>
        <table-column
          :label="$t('islamic_finance.islamic_finance_number')"
          show="islamic_finance_number"
        />
        <table-column
          :label="$t('islamic_finance.payment_date')"
          show="formattedPaymentDate"
        />
        <table-column
          :label="$t('islamic_finance.delivery_date')"
          show="formattedDeliveryDate"
        />
        <table-column
          v-if="userType === 'funder' || userType === 'auditor'"
          :label="$t('islamic_finance.supplier')"
        >
          <template slot-scope="row">
            <p v-if="row.customer">
              <span
                v-if="
                  row.customer.company_name
                "
              >
                {{ row.customer.company_name }}
              </span>
            </p>
          </template>
        </table-column>
        <!-- <table-column :label="$t('islamic_finance.customer')">
          <template slot-scope="row">
            <p v-if="row.supplier_stakeholder && userType === 'funder'">
              <span
                v-if="
                  row.supplier_stakeholder.details.company &&
                    row.supplier_stakeholder.details.company.name
                "
              >
                {{ row.supplier_stakeholder.details.company.name }}
              </span>
            </p>
            <p v-if="row.buyer_stakeholder && userType === 'supplier'">
              <span
                v-if="
                  row.customer.parent_account_id &&
                    row.buyer_stakeholder.details.company &&
                    row.buyer_stakeholder.details.company.name
                "
              >
                {{ row.buyer_stakeholder.details.company.name }}
              </span>
              <span v-else-if="row.customer.parent_account_id == null">
                {{ row.buyer_stakeholder.details.user.name }}
              </span>
              <span v-else>
                {{ row.buyer_stakeholder.details.company.name }}
              </span>
            </p>
            <p v-if="row.buyer_stakeholder && userType === 'auditor'">
              <span
                v-if="
                  row.customer.parent_account_id &&
                    row.buyer_stakeholder.details.company &&
                    row.buyer_stakeholder.details.company.name
                "
              >
                {{ row.buyer_stakeholder.details.company.name }}
              </span>
              <span v-else-if="row.customer.parent_account_id == null">
                {{ row.buyer_stakeholder.details.user.name }}
              </span>
              <span v-else>
                {{ row.buyer_stakeholder.details.company.name }}
              </span>
            </p>
          </template>
        </table-column> -->
        <table-column :label="$t('invoices.amount')" sort-as="total">
          <template slot-scope="row">
            <span>{{ $t("invoices.amount") }}</span>
            <div
              v-html="$utils.formatMoney(row.total, row.customer.currency)"
            />
          </template>
        </table-column>
        <table-column :label="$t('invoices.status')" sort-as="status">
          <template v-if="row.status" slot-scope="row">
            <span> {{ $t("invoices.status") }}</span>
            <span
              v-if="row.status === 'OFFER_TO_SELL_ACCEPT'"
              :class="'status-offer-to-sell-accept'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'OFFER_TO_SELL_REJECT'"
              :class="'status-offer-to-sell-reject'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'NOTICE_OF_DELIVERY_ISSUED'"
              :class="'status-offer-to-sell-delivery'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'AGENT_APPOINTED'"
              :class="'status-offer-to-sell-agent-appointed'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'SALE_CONFIRMED'"
              :class="'status-offer-to-sell-confirmed-sale'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'AGENCY_PENDING'"
              :class="'status-agency-pending'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'AGENCY_ACCEPTED'"
              :class="'status-agency-accepted'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'AGENCY_REJECTED'"
              :class="'status-agency-rejected'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'INVOICE_INFORMATION_ADDED'"
              :class="'status-offer-to-sell-invoice-info-added'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>
            <span
              v-else-if="row.status === 'INVOICE_VERIFIED'"
              :class="'status-offer-to-sell-invoice-verification'"
            >
              {{ row.status.replaceAll("_", " ") }}
            </span>

            <span
              v-else
              :class="'inv-status-' + row.status.toLowerCase()"
              v-html="row.status"
            />
          </template>
        </table-column>
        <table-column
          :label="$t('funders.added_on')"
          sort-as="created_at"
          show="formattedCreatedAt"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row" if="row.status != 'EXPIRED'">
            <span> {{ $t("funders.action") }} </span>
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <a
                  v-if="userType != 'auditor'"
                  :href="`/offerToSell/pdf/${row.unique_hash}`"
                  target="_blank"
                  class="dropdown-item"
                >
                  <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                  {{ $t("islamic_finance.view_offer_to_sell") }}
                </a>
              </v-dropdown-item>
              <!--draft && supplier-->
              <v-dropdown-item
                v-if="row.status == 'DRAFT' && userType === 'supplier'"
              >
                <a class="dropdown-item" @click="editOffer(row.id)">
                  <font-awesome-icon
                    :icon="['fas', 'pencil-alt']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.edit") }}
                </a>
                <a class="dropdown-item" @click="sendOffer(row)">
                  <font-awesome-icon
                    :icon="['fas', 'paper-plane']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.send_offer") }}
                </a>
                <a class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>
              <!--offer && funder-->
              <v-dropdown-item
                v-if="row.status === 'OFFER' && userType === 'funder'"
              >
                <div v-if="row.downloaded || hasNoCurrentAttachments(row)" class="dropdown-item" @click="acceptOffer(row)">
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.accept_offer") }}
                </div>
                <div
                  v-if="row.status === 'OFFER'"
                  class="dropdown-item"
                  @click="rejectOffer(row.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'times']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.reject_offer") }}
                </div>
                <a v-if="!row.downloaded && !hasNoCurrentAttachments(row)" class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>

              <!--accept && supplier-->
              <v-dropdown-item
                v-if="
                  row.status === 'OFFER_TO_SELL_ACCEPT' && userType === 'funder'
                "
              >
                <div class="dropdown-item" @click="sendNoticeDelivery(row)">
                  <font-awesome-icon
                    :icon="['fas', 'paper-plane']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("islamic_finance.send_notice_delivery") }}
                </div>
                <a class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>

              <!--notice delivery && funder-->
              <v-dropdown-item
                v-if="
                  row.status === 'NOTICE_OF_DELIVERY_ISSUED' &&
                    userType === 'funder'
                "
              >
                <div class="dropdown-item" @click="sendAppointAgency(row)">
                  <font-awesome-icon
                    :icon="['fas', 'paper-plane']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("islamic_finance.send_appoint_agency") }}
                </div>
                <a class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>

              <!--AGENT APPOINTED && supplier-->
              <v-dropdown-item
                v-if="row.status === 'AGENT_APPOINTED' && userType === 'supplier'"
              >
                <a class="dropdown-item" @click="addInvoiceInfo(row.id)">
                  <font-awesome-icon
                    :icon="['fas', 'plus']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("islamic_finance.add_invoice_information") }}
                </a>
                <a class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>

              <!--INVOICE INFORMATION ADDED && supplier-->
              <v-dropdown-item
                v-if="row.status === 'INVOICE_INFORMATION_ADDED' && userType === 'supplier'"
              >
                <div class="dropdown-item" @click="confirmSale(row)">
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("islamic_finance.confirm_sale") }}
                </div>
                <a class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>

              <!--AGENCY REJECTED && supplier-->
              <v-dropdown-item
                v-if="row.status === 'AGENCY_REJECTED' && userType === 'supplier'"
              >
                <a class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>

              <!--AGENCY PENDING && supplier-->
              <v-dropdown-item
                v-if="row.status === 'AGENCY_PENDING' && userType === 'supplier'"
              >
                <div class="dropdown-item" @click="responseToOffer(row)">
                  <font-awesome-icon :icon="['fas', 'check-circle']" class="dropdown-item-icon" />
                  {{ $t("islamic_finance.response_to_offer") }}
                </div>
              </v-dropdown-item>
              <!--AGENCY PENDING && funder-->
              <v-dropdown-item
                v-if="row.status === 'AGENCY_PENDING' && userType === 'funder'"
              >
                <a class="dropdown-item" @click="attachments(row.id)">
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </a>
              </v-dropdown-item>

              <!--invoice verification  && supplier-->
              <v-dropdown-item v-if="row.status === 'SALE_CONFIRMED' && userType === 'supplier'">
                <a
                  class="dropdown-item"
                  @click="invoiceVerficaion(row.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("islamic_finance.invoice_verification") }}
                </a>
              </v-dropdown-item>

              <v-dropdown-item>
                <a
                  v-if="row.status != 'DRAFT'"
                  class="dropdown-item"
                  @click="recordPage(row.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'history']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.action_record") }}
                </a>
              </v-dropdown-item>
              <v-dropdown-item v-if="row.status === 'OFFER'">
                <a
                  class="dropdown-item"
                  target="_blank"
                  @click="downloadOffer(row.id, row.status)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'download']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.download_offer") }}
                </a>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
    <div v-if="showNoAttachmentsModal" class="modal-fallback" @click.self="closeNoAttachmentsModal">
      <div class="no-attachments-modal-content">
        <button type="button" class="no-attachments-modal-close" @click="closeNoAttachmentsModal">×</button>
        <h3>{{ $te('islamic_finance.no_attachments_found') ? $t('islamic_finance.no_attachments_found') : 'No attachments found' }}</h3>
        <p>{{ $te('islamic_finance.no_attachments_found_text') ? $t('islamic_finance.no_attachments_found_text') : 'No attachments found. Please add attachments to proceed.' }}</p>
        <div class="no-attachments-modal-actions">
          <base-button color="theme" @click="confirmNoAttachments">{{ $te('general.ok') ? $t('general.ok') : 'OK' }}</base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import DotIcon from '../../components/icon/DotIcon'
import AstronautIcon from '../../components/icon/AstronautIcon'
import BaseButton from '../../../js/components/base/BaseButton'
import SingleFunderRow from '../funders/SingleFunderRow.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons'
library.add(faCommentDots)
export default {
  components: {
    DotIcon,
    AstronautIcon,
    SweetModal,
    SweetModalTab,
    BaseButton,
    SingleFunderRow
  },
  data () {
    return {
      advanceOption: true,
      showFilters: false,
      filtersApplied: false,
      isRequestOngoing: true,
      showNoAttachmentsModal: false,
      pendingNoAttachmentsRowId: null,
      filters: {
        display_name: '',
        contact_name: '',
        phone: ''
      },
      fetchDataFunder: [],
      userType: null,
      sendTermCondition: null,
      saleConfirmedTermCondition: null,
      islamicForm: null
    }
  },
  computed: {
    ...mapGetters('OfferToSell', [
      'offerToSells',
      'selectedOfferToSells',
      'totalOfferToSells',
      'selectAllField'
    ]),
    ...mapGetters('islamicFinanceForm', ['islamicFinanceForm']),
    showEmptyScreen () {
      return (
        !this.totalOfferToSells &&
        !this.isRequestOngoing &&
        !this.filtersApplied
      )
    },
    filterIcon () {
      return this.showFilters ? 'times' : 'filter'
    },
    selectField: {
      get: function () {
        return this.selectedOfferToSells
      },
      set: function (val) {
        this.selectOfferToSell(val)
      }
    },
    selectAllFieldStatus: {
      get: function () {
        return this.selectAllField
      },
      set: function (val) {
        this.setSelectAllState(val)
      }
    },
    offerAcceptForm () {
      return this.islamicFinanceForm.find(x => x.name === 'Offer Accepted')
    },
    agentAppointmentForm () {
      return this.islamicFinanceForm.find(
        x => x.name === 'Documentation Complete'
      )
    },
    noticeDeliveryForm () {
      return this.islamicFinanceForm.find(x => x.name === 'Notice of Delivery')
    }
  },
  watch: {
    filters: {
      handler: 'setFilters',
      deep: true
    }
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
      this.loadFunder()
    } else if (localStorage.getItem('account_type') === 'auditor') {
      this.userType = 'auditor'
    }
    this.islamicFormData()
  },

  destroyed () {
    if (this.selectAllField) {
      this.selectAllOfferToSells()
    }
  },
  mounted () {},
  methods: {
    ...mapActions('customer', ['singleCustomerArray']),

    ...mapActions('OfferToSell', [
      'fetchOfferToSells',
      'selectAllOfferToSells',
      'selectOfferToSell',
      'setSelectAllState',
      'markAsReject',
      'fetchAttachments',
      'fetchAttachmentsByStatus',
      'markAsAutoInvoiceVerification',
      'markAsAgencyAccepted',
      'markAsAgencyRejected'
    ]),
    ...mapActions('islamicFinanceForm', ['islamicFormData']),
    ...mapActions('modal', ['openModal']),
    ...mapActions('funder', ['singleFunderArray']),
    refreshTable () {
      this.$refs.table.refresh()
    },
    hasNoCurrentAttachments (row) {
      const currentStatus = row && row.islamic_finance_current_status ? row.islamic_finance_current_status : null
      const attachments = currentStatus && Array.isArray(currentStatus.attachments) ? currentStatus.attachments : []
      const media = currentStatus && Array.isArray(currentStatus.media) ? currentStatus.media : []
      return attachments.length === 0 && media.length === 0
    },
    async loadFunder () {
      let response = await this.singleFunderArray(this.$route.params.id)
      this.fetchDataFunder = response.data.account
      this.sendTermCondition = response.data.sendTermCondition
      this.sendNoticeDeliveryForm = response.data.noticeDeliveryTermCondition
      this.saleConfirmedTermCondition =
        response.data.saleConfirmedTermCondition
      if (response.data.form) {
        this.islamicForm = true
      }
      // this.islamicForm = response.data.form
    },
    async fetchData ({ page, perPage, filter, sort }) {
      let data = null
      if (this.userType === 'auditor') {
        data = {
          orderByField: sort.fieldName || 'created_at',
          orderBy: sort.order || 'desc',
          per_page: perPage, // Add rowsPerPage in the API request
          page
        }
      } else {
        data = {
          funder_user_id: this.$route.params.id,
          orderByField: sort.fieldName || 'created_at',
          orderBy: sort.order || 'desc',
          per_page: perPage, // Add rowsPerPage in the API request
          page
        }
      }

      this.isRequestOngoing = true
      let response = await this.fetchOfferToSells(data)
      if (this.userType === 'funder') {
        this.islamicForm = response.data.islamicFormId
      }
      this.isRequestOngoing = false

      return {
        data: response.data.offerToSells.data,
        pagination: {
          totalPages: response.data.offerToSells.last_page,
          currentPage: page,
          rowsPerPage: response.data.offerToSells.per_page // Add rowsPerPage in the API request
        }
      }
    },
    setFilters () {
      this.filtersApplied = true
      this.refreshTable()
    },
    clearFilter () {
      this.filters = {
        display_name: '',
        contact_name: '',
        phone: ''
      }

      this.$nextTick(() => {
        this.filtersApplied = false
      })
    },
    toggleFilter () {
      if (this.showFilters && this.filtersApplied) {
        this.clearFilter()
        this.refreshTable()
      }

      this.showFilters = !this.showFilters
    },
    async sendOffer (row) {
      const data = { islamic_finance_id: row.id, type: 'offer_sent' }
      let response = await this.fetchAttachmentsByStatus(data)
      console.log('response.data.media', response.data.media)
      if (response.data.media.length > 0) {
        let content = ''
        if (response.data.content !== '') {
          content = response.data.content
        }
        this.openModal({
          title: this.sendTermCondition['title'],
          componentName: 'IslamicFinanceSendOfferModal',
          id: row.id,
          data: {
            name: this.sendTermCondition['name'],
            message: this.sendTermCondition['message'],
            items: response.data.islamicFinance.media,
            content: content,
            row: row
          }
        })
      } else {
        this.pendingNoAttachmentsRowId = row.id
        this.showNoAttachmentsModal = true
      }
    },
    closeNoAttachmentsModal () {
      this.showNoAttachmentsModal = false
      this.pendingNoAttachmentsRowId = null
    },
    confirmNoAttachments () {
      const id = this.pendingNoAttachmentsRowId
      this.closeNoAttachmentsModal()
      if (id) {
        this.attachments(id)
      }
    },
    async acceptOffer (row) {
      const data = { islamic_finance_id: row.id, type: 'offer_accepted' }
      let response = await this.fetchAttachmentsByStatus(data)
      let content = ''
      if (response.data.content !== '') {
        content = response.data.content
      }
      this.openModal({
        title: this.offerAcceptForm['title'],
        componentName: 'IslamicFinanceSendOfferModal',
        id: row.id,
        data: {
          name: this.offerAcceptForm['name'],
          message: this.offerAcceptForm['message'],
          items: response.data.islamicFinance.media,
          content: content,
          nextStep: this.sendNoticeDelivery,
          row: row
        }
      })
    },
    async sendNoticeDelivery (row) {
      const data = { islamic_finance_id: row.id, type: 'notice_of_delivery' }
      let response = await this.fetchAttachmentsByStatus(data)
      let content = ''
      if (response.data.content !== '') {
        content = response.data.content
      }
      this.openModal({
        title: this.noticeDeliveryForm['title'],
        componentName: 'IslamicFinanceSendOfferModal',
        id: row.id,
        data: {
          name: this.noticeDeliveryForm['name'],
          message: this.noticeDeliveryForm['message'],
          items: response.data.islamicFinance.media,
          content: content,
          nextStep: this.sendAppointAgency,
          row: row
        }
      })
    },
    async sendAppointAgency (row) {
      const data = {
        islamic_finance_id: row.id,
        type: 'documentation_complete'
      }
      let response = await this.fetchAttachmentsByStatus(data)
      let content = ''
      if (response.data.content !== '') {
        content = response.data.content
      }
      this.openModal({
        title: this.agentAppointmentForm['title'],
        componentName: 'IslamicFinanceSendOfferModal',
        id: row.id,
        data: {
          name: this.agentAppointmentForm['name'],
          message: this.agentAppointmentForm['message'],
          items: response.data.islamicFinance.media,
          content: content
        }
      })
    },
    async confirmSale (row) {
      const data = { islamic_finance_id: row.id, type: 'confirmation_of_sale' }
      let response = await this.fetchAttachmentsByStatus(data)
      let content = ''
      if (response.data.content !== '') {
        content = response.data.content
      }
      this.openModal({
        title: this.saleConfirmedTermCondition['title'],
        componentName: 'IslamicFinanceSendOfferModal',
        id: row.id,
        data: {
          name: this.saleConfirmedTermCondition['name'],
          message: this.saleConfirmedTermCondition['message'],
          items: response.data.islamicFinance.media,
          content: content
        }
      })
    },
    async rejectOffer (id) {
      const data = {
        islamic_finance_id: id
      }
      let response = await this.markAsReject(data)
      if (response.data.success) {
        this.isLoading = false
        window.toastr['success'](
          this.$tc('islamic_finance.mark_as_rejected_message')
        )
        return true
      }
    },
    async newOfferSellPage (row) {
      this.$router.push(
        `/supplier/offer-to-sell/${this.$route.params.id}/create`
      )
    },
    editOffer (id) {
      this.$router.push(`/supplier/offer-to-sell/${id}/edit`)
    },
    async invoiceVerficaion (id) {
      const data = {
        islamic_finance_id: id,
        funder_id: this.$route.params.id
      }
      let response = await this.markAsAutoInvoiceVerification(data)
      if (response.data.success) {
        this.isLoading = false
        window.toastr['success'](
          this.$t('islamic_finance.invoice_verification_successfully')
        )
        this.$router.push(
          `/supplier/funders/${
            this.$route.params.id
          }/islamic_finance/${id}/record`
        )
      } else {
        this.$router.push(
          `/supplier/funders/${
            this.$route.params.id
          }/islamic_finance/${id}/invoiceVerification`
        )
      }
    },
    addInvoiceInfo (id) {
      this.$router.push(
        `/supplier/funders/${
          this.$route.params.id
        }/islamic_finance/${id}/addInvoiceInfo`
      )
    },
    attachments (id) {
      if (this.userType === 'funder') {
        this.$router.push(`islamic-finances/${id}/attachments`)
      } else if (this.userType === 'supplier') {
        this.$router.push(
          `/supplier/funders/${
            this.$route.params.id
          }/islamic_finance/${id}/attachments`
        )
      }
    },
    recordPage (id) {
      if (this.userType === 'funder') {
        this.$router.push(`islamic-finances/${id}/record`)
      } else if (this.userType === 'supplier') {
        this.$router.push(
          `/supplier/funders/${
            this.$route.params.id
          }/islamic_finance/${id}/record`
        )
      } else if (this.userType === 'auditor') {
        this.$router.push(`islamic-finances/${id}/record`)
      }
    },
    downloadOffer (id, status) {
      window.open(`/download-islamic-finance/${id}/offer/${status}`, '_blank')
    },
    responseToOffer (row) {
      const content = document.createElement('div')
      content.innerHTML = `
        <p style="text-align: center;">As an agent, I have reviewed the form and accept all the conditions mentioned below:</p>
        <ul style="text-align: left; margin-left: 50px; padding-left: 50px;">
          <li style="margin-bottom: 8px; color: #333;">${this.$t('islamic_finance.acceptance_written_offer')}</li>
          <li style="margin-bottom: 8px; color: #333;">${this.$t('islamic_finance.finished_goods_receiving_note')}</li>
          <li style="margin-bottom: 0; color: #333;">${this.$t('islamic_finance.notice_tijarah_transaction')}</li>
        </ul>
      `

      window.swal({
        title: 'Response to GRN / NTS',
        content: content,
        icon: 'warning',
        buttons: {
          cancel: {
            text: this.$t('general.reject'),
            value: 'reject',
            visible: true,
            className: 'swal-button--cancel'
          },
          confirm: {
            text: this.$t('general.accept'),
            value: 'accept',
            visible: true,
            className: 'swal-button--confirm'
          },
          close: {
            text: '×',
            value: null,
            visible: true,
            className: 'swal-button--close',
            closeModal: true
          }
        },
        dangerMode: true,
        closeOnClickOutside: false,
        closeOnEsc: true,
        allowOutsideClick: false,
        allowEscapeKey: true
      }).then(async value => {
        if (value === 'accept') {
          await this.acceptAgency(row)
        } else if (value === 'reject') {
          await this.rejectAgency(row.id)
        }
        // If value is null/undefined (user clicked outside, escaped, or clicked close), do nothing
      }).catch(() => {
        // Handle any errors without changing status
      })
    },
    async acceptAgency (row) {
      const data = {
        islamic_finance_id: row.id
      }
      let response = await this.markAsAgencyAccepted(data)
      if (response.data.success) {
        this.isLoading = false
        window.toastr['success'](
          this.$tc('islamic_finance.mark_as_agency_accepted_message')
        )
        this.refreshTable()
        return true
      }
    },
    async rejectAgency (id) {
      const data = {
        islamic_finance_id: id
      }
      let response = await this.markAsAgencyRejected(data)
      if (response.data.success) {
        this.isLoading = false
        window.toastr['success'](
          this.$tc('islamic_finance.mark_as_agency_rejected_message')
        )
        this.refreshTable()
        return true
      }
    }
  }
}
</script>
<style>
.modal-fallback {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-attachments-modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 300px;
  max-width: 560px;
  width: 90%;
  box-shadow: 0 2px 16px rgba(0,0,0,0.2);
  text-align: center;
  position: relative;
}

.no-attachments-modal-actions {
  margin-top: 1.5rem;
}

.no-attachments-modal-close {
  position: absolute;
  top: 8px;
  right: 12px;
  width: 30px;
  height: 30px;
  border: none;
  background: #f8f9fa;
  color: #6c757d;
  font-size: 18px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}

.no-attachments-modal-close:hover {
  background: #e9ecef;
  color: #495057;
}

/* Restore SweetAlert close button styling used in other dialogs */
.swal-button--close {
  background: #f8f9fa !important;
  color: #6c757d !important;
  width: 30px !important;
  height: 30px !important;
  font-size: 18px !important;
  font-weight: bold !important;
  line-height: 1 !important;
  padding: 0 !important;
  position: absolute !important;
  top: -408px !important;   /* Position close button near top-right of swal */
  right: -15px !important;
  margin: 0 !important;
  z-index: 9999 !important;
}

.swal-button--close:hover {
  background: #e9ecef !important;
  color: #495057 !important;
}

/* Removed overriding styles for global SweetAlert close button to avoid side effects */

/* Ensure the warning icon displays properly */
.swal2-icon.swal2-warning {
  border-color: #ffc107 !important;
  color: #ffc107 !important;
}

/* Reject Button (like "Cancel") */
.swal-button--cancel {
  background-color: #ffffff !important;
  color: #212529 !important; /* Bootstrap dark */
  border: 1px solid #6c757d !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  font-weight: 500 !important;
}

/* Accept Button (like "Confirmation of Sale") */
.swal-button--confirm {
  background-color: #5a5a5a !important; /* Dark gray */
  color: #ffffff !important;
  border: none !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  font-weight: 600 !important;
}

.swal-button-send-offer-confirm {
  background-color: #5a5a5a !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  font-weight: 600 !important;
}
.swal-button-send-offer-close {
  background: #f8f9fa !important;
  color: #6c757d !important;
  width: 30px !important;
  height: 30px !important;
  font-size: 18px !important;
  font-weight: bold !important;
  line-height: 1 !important;
  padding: 0 !important;
  position: absolute !important;
  top: -408px !important;
  right: -15px !important;   /* Adjusted to move it right */
  margin: 0 !important;
  z-index: 9999 !important;
}
.swal-button-send-offer-close:hover {
  background: #e9ecef !important;
  color: #495057 !important;
}
/* Agency Status Styles */
</style>
